import { BrowserRouter, Route, Routes } from 'react-router';
import { AddItemPage } from './admin/AddItemPage';
import { AdminHome } from './admin/AdminHome';
import { EditItemPage } from './admin/EditItemPage';
import { InquiriesPage } from './admin/InquiriesPage';
import { SaleSettingsPage } from './admin/SaleSettingsPage';
import { RequireAuth } from './admin/auth';
import { LoginPage } from './admin/LoginPage';
import { SaleDashboard } from './admin/SaleDashboard';
import { ItemPage } from './public/ItemPage';
import { SalePage } from './public/SalePage';
import { PrivacyPage } from './public/PrivacyPage';
import { TermsPage } from './public/TermsPage';
import { StartSellingPage } from './public/StartSellingPage';
import { RequestsPage } from './platform/RequestsPage';
import { HomePage } from './public/HomePage';
import { SetPasswordPage } from './admin/SetPasswordPage';
import { PlatformLayout } from './platform/PlatformLayout';
import { DashboardPage } from './platform/DashboardPage';
import { SellersPage } from './platform/SellersPage';
import { SellerNewPage } from './platform/SellerNewPage';
import { SellerPage } from './platform/SellerPage';
import { SalesPage } from './platform/SalesPage';
import { SaleFormPage } from './platform/SaleFormPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/set-password" element={<SetPasswordPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/start" element={<StartSellingPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/admin" element={<AdminHome />} />
          <Route path="/admin/sales/:saleId" element={<SaleDashboard />} />
          <Route path="/admin/sales/:saleId/add" element={<AddItemPage />} />
          <Route path="/admin/sales/:saleId/items/:itemId" element={<EditItemPage />} />
          <Route path="/admin/sales/:saleId/inquiries" element={<InquiriesPage />} />
          <Route path="/admin/sales/:saleId/settings" element={<SaleSettingsPage />} />
          <Route path="/platform-admin" element={<PlatformLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="requests" element={<RequestsPage />} />
            <Route path="sellers" element={<SellersPage />} />
            <Route path="sellers/new" element={<SellerNewPage />} />
            <Route path="sellers/:sellerId" element={<SellerPage />} />
            <Route path="sales" element={<SalesPage />} />
            <Route path="sales/new" element={<SaleFormPage />} />
            <Route path="sales/:saleId" element={<SaleFormPage />} />
          </Route>
        </Route>
        <Route path="/:slug" element={<SalePage />} />
        <Route path="/:slug/item/:number" element={<ItemPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export function NotFound({ message = "We couldn't find that page." }: { message?: string }) {
  return (
    <main className="page narrow center">
      <h1>Not found</h1>
      <p className="muted">{message}</p>
    </main>
  );
}
